export const FETCH_FITNESSSTATS_ACTIVITY = 'FETCH_FITNESSSTATS_ACTIVITY';
export const FETCH_FITNESSSTATS_ACTIVITY_SUCCESS = 'FETCH_FITNESSSTATS_ACTIVITY_SUCCESS';
export const FETCH_FITNESSSTATS_ACTIVITY_FETCHING = 'FETCH_FITNESSSTATS_ACTIVITY_FETCHING';
export const FETCH_FITNESSSTATS_ACTIVITY_ERROR = 'FETCH_FITNESSSTATS_ACTIVITY_ERROR';
export const FETCH_RECENT_FITNESSSTATS_ACTIVITY = 'FETCH_RECENT_FITNESSSTATS_ACTIVITY';
export const FETCH_RECENT_FITNESSSTATS_ACTIVITY_SUCCESS = 'FETCH_RECENT_FITNESSSTATS_ACTIVITY_SUCCESS';
export const FETCH_RECENT_FITNESSSTATS_ACTIVITY_FETCHING = 'FETCH_RECENT_FITNESSSTATS_ACTIVITY_FETCHING';
export const FETCH_RECENT_FITNESSSTATS_ACTIVITY_ERROR = 'FETCH_RECENT_FITNESSSTATS_ACTIVITY_ERROR';

export const FETCH_USER_AVERAGE_PACE = 'FETCH_USER_AVERAGE_PACE';
export const FETCH_USER_AVERAGE_PACE_SUCCESS = 'FETCH_USER_AVERAGE_PACE_SUCCESS';
export const FETCH_USER_AVERAGE_PACE_FETCHING = 'FETCH_USER_AVERAGE_PACE_FETCHING';
export const FETCH_USER_AVERAGE_PACE_ERROR = 'FETCH_USER_AVERAGE_PACE_ERROR';

export const FETCH_ALL_FITNESSSTATS_ACTIVITY = 'FETCH_ALL_FITNESSSTATS_ACTIVITY';
export const FETCH_ALL_FITNESSSTATS_ACTIVITY_SUCCESS = 'FETCH_ALL_FITNESSSTATS_ACTIVITY_SUCCESS';
export const FETCH_ALL_FITNESSSTATS_ACTIVITY_FETCHING = 'FETCH_ALL_FITNESSSTATS_ACTIVITY_FETCHING';
export const FETCH_ALL_FITNESSSTATS_ACTIVITY_ERROR = 'FETCH_ALL_FITNESSSTATS_ACTIVITY_ERROR';
